import getStore from '../store';
import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import { ObservableMap } from 'mobx';

export default function getAllResults(): ObservableMap<string, SearchResultItem[]> {
    const store = getStore();

    if (!store.searchResults) {
        return null;
    }

    const results = new ObservableMap<string, SearchResultItem[]>();
    store.searchResults.forEach((value, key) => {
        results.set(key, [...value.values()]);
    });

    return results;
}
